import React, { FC, ReactNode } from 'react';

import { Box, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

interface IPaymentMethodDescription {
  methodName: string;
  amountDescription?: ReactNode;
}

export const PaymentMethodDescription: FC<IPaymentMethodDescription> = ({
  methodName,
  amountDescription = null,
}) => {
  return (
    <Box ml="$2" flexDirection="row">
      <Text color={theme.token('text-default')}>
        {methodName}
        {amountDescription}
      </Text>
    </Box>
  );
};
